<template>
  <div>
    <!-- tab开始 -->
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane
        :label="'全部 ' + '(' + pageConfig.total + ')'"
        name="all"
      ></el-tab-pane>
      <el-tab-pane
        :label="'待审核 ' + '(' + allKinds.auditCount + ')'"
        name="10"
      ></el-tab-pane>
      <el-tab-pane
        :label="'已审核 ' + '(' + allKinds.reviewedCount + ')'"
        name="20"
      ></el-tab-pane>
      <el-tab-pane
        :label="'已签收 ' + '(' + allKinds.signInCount + ')'"
        name="30"
      ></el-tab-pane>
      <el-tab-pane
        :label="'部分签收 ' + '(' + allKinds.partialSignInCount + ')'"
        name="35"
      ></el-tab-pane>
      <el-tab-pane
        :label="'部分收货 ' + '(' + allKinds.partialReceiptCount + ')'"
        name="40"
      ></el-tab-pane>
      <el-tab-pane
        :label="'强制完成 ' + '(' + allKinds.forceCompleteCount + ')'"
        name="45"
      ></el-tab-pane>
      <el-tab-pane
        :label="'收货完成 ' + '(' + allKinds.receiptCompletedCount + ')'"
        name="50"
      ></el-tab-pane>
      <el-tab-pane
        :label="'异常 ' + '(' + allKinds.abnormalCount + ')'"
        name="88"
      ></el-tab-pane>
      <el-tab-pane
        :label="'取消 ' + '(' + allKinds.cancelCount + ')'"
        name="99"
      ></el-tab-pane>
    </el-tabs>
    <!-- tab结束 -->

    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      :pageConfig="pageConfig"
      :buttonList="buttonList"
      @btnCallFunction="callFunction"
      @resetBtn="resetBtn"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
      <template v-slot:WarehouseId>
        <el-select
          multiple
          filterable
          v-model="filters.WarehouseId"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in warehouses"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:Status>
        <el-select
          multiple
          filterable
          v-model="filters.Status"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in statusList"
            :label="item.text"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:OrgIds>
        <el-select
          multiple
          filterable
          v-model="filters.OrgIds"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in organizationList"
            :label="item.customName"
            :value="item.organizationId"
            :key="item.organizationId"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:tdate>
        <el-select
          class="dateSelect"
          v-model="filters.DateType"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in DateTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-date-picker
          v-model="filters.tdate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </template>

      <template slot-scope="scope" slot="deliveryOrdeNo">
        <hoverCopy>
          <el-link
            slot="referenceChild"
            :underline="false"
            type="primary"
            @click.native="batchesDetail(scope.row)"
            >{{ scope.row.deliveryOrdeNo }}
          </el-link>
        </hoverCopy>
      </template>
      <template slot-scope="scope" slot="resynchronize">
        <div>
          <el-button
            style="margin-left: 10px"
            :underline="false"
            type="text"
            size="small"
            @click.native="getbusinessLoglist(scope.row)"
          >
            查看日志
          </el-button>
          <br />
        </div>
      </template>

      <template slot-scope="scope" slot="isTransit">
        <span>
          {{ scope.row.isTransit > 0 ? "是" : "否" }}
        </span>
      </template>

      <template slot-scope="scope" slot="deliveryBooking">
        <span v-if="scope.row.isBooking > 0">
          <el-link
            :underline="false"
            type="primary"
            @click.native="getBoxMarkTransfer(scope.row.deliveryOrdeNo)"
            >查看
          </el-link>
        </span>
      </template>
    </TwTable>

    <WarehouseNoDetail ref="WarehouseNoDetailRef" />
    <LogDialog
      :logPageConfig="logPageConfig"
      :showLog="showLog"
      :requestData="{
        businessType: 33,
        businessCode: currentRow.deliveryOrdeNo,
      }"
      :requestApi="'/WareHouse/BusinessLogServices'"
      :requestMethod="'get'"
      v-if="showLog"
      @showDialog="showDialog"
    >
    </LogDialog>
    <!-- 签收 -->
    <el-dialog
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="签收"
      width="30%"
      :before-close="onSubmicancel"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addRuleForm"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="WMS进仓号"
              prop="DeliveryOrdeNo"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.DeliveryOrdeNo"
                auto-complete="off"
                maxlength="50"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="参考单号"
              prop="orgCustomerNo"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.orgCustomerNo"
                auto-complete="off"
                maxlength="50"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="inline">
          <el-row>
            <el-col :span="24">
              <el-form-item
                label="预报总箱数"
                prop="BoxCount"
                class="labelcall"
                label-width="120px"
              >
                <el-input
                  v-model="addForm.BoxCount"
                  auto-complete="off"
                  maxlength="50"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item
                label="实收箱数"
                prop="ReceivedBoxCount"
                class="labelcall"
                label-width="120px"
              >
                <el-input
                  v-model="addForm.ReceivedBoxCount"
                  auto-complete="off"
                  maxlength="50"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="inline">
          <el-row>
            <el-col :span="24">
              <el-form-item
                label="过机箱数"
                prop="MachineBoxCount"
                class="labelcall"
                label-width="120px"
              >
                <el-input
                  v-model="addForm.MachineBoxCount"
                  auto-complete="off"
                  maxlength="50"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-checkbox v-model="addForm.IsSyc" @change="machineSyc"
              >同步</el-checkbox
            >
          </el-row>
        </div>
        <el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item
                label="签收箱数"
                prop="ActualBoxCount"
                class="labelcall"
                label-width="120px"
              >
                <el-input
                  v-model="addForm.ActualBoxCount"
                  auto-complete="off"
                  placeholder="请输入签收箱数"
                  type="number"
                  maxlength="50"
                  min="0"
                  :disabled="isDisabled"
                  @input="
                    addForm.ActualBoxCount = addForm.ActualBoxCount.replace(
                      /^(0+)|[^\d]+/g,
                      ''
                    )
                  "
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item
                label="实际到仓时间"
                prop="ActualArriveDate"
                class="labelcall actualArriveDate"
                label-width="120px"
              >
                <el-date-picker
                  v-model="addForm.ActualArriveDate"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
             
            <div class="warehouseCls">
              <!--  <el-checkbox v-model="addForm.IsUnload">仓库卸货</el-checkbox> -->
              <el-checkbox-group
                v-model="addForm.IsUnload"
                @change="changeCheck"
              >
                <el-checkbox label="cargoSelfUnloading">货主自卸</el-checkbox>
                <el-checkbox label="warehouseUnloading">仓库卸货</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item
                label="备注"
                prop="Remark"
                class="labelcall"
                label-width="120px"
              >
                <el-input
                  v-model="addForm.Remark"
                  auto-complete="off"
                  type="textarea"
                  autosize
                  maxlength="200"
                  show-word-limit
                  :autosize="{ minRows: 2, maxRows: 4 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
          <el-button @click="onSubmicancel">取消</el-button>
          <el-button
            type="primary"
            @click="onAddSubmit"
            :loading="addLoading"
            v-no-more-click
            >签收</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
    <!-- 新增入库单 -->
    <ReceiptNoDalog ref="ReceiptNoRef"></ReceiptNoDalog>

    <!-- 打印进仓单 -->
    <el-dialog
      :visible.sync="printPickListVisible"
      v-model="printPickListVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      class="printDalog"
      title="打印进仓单"
      width="925px"
      style="text-align: center"
    >
      <el-row type="flex" class="row-bg printRow">
        <div class="print">
          <!-- <el-button type="primary" v-print="printObj" @click="printLoadCar"
            >打印</el-button> -->
          <el-button
            v-print="printObj"
            type="primary"
            @click="printDeliveryOrder"
            >打印</el-button
          >
        </div>
      </el-row>

      <div id="printReceiptManage" class="printReceipt" ref="printContent">
        <div v-html="styleText"></div>
        <div class="printReceipt-remark">
          严禁危化品和易爆.高爆物品进仓，后果由隐瞒者承担!
        </div>
        <div class="printReceipt-warehouseName">
          {{ deliveryOrderPrint.warehouseName }}
        </div>
        <div class="printReceipt-barcode">
          <img id="barcode1" />
        </div>
        <div class="printReceipt-singerItem">
          <span>进仓编号</span>
          <el-input
            :value="deliveryOrderPrint.deliveryOrdeNo"
            readonly
          ></el-input>
          <span>(必须打印)</span>
        </div>
        <div class="printReceipt-item">
          <div>
            <span>车牌号</span>
            <el-input v-model="deliveryOrderPrint.numberPlate"></el-input>
          </div>
          <div>
            <span>手机号</span>
            <el-input v-model="deliveryOrderPrint.driverPhone"></el-input>
          </div>
        </div>
        <div class="printReceipt-singerItem">
          <span>送货单位</span>
          <el-input :value="deliveryOrderPrint.deliveryUnit"></el-input>
          <span>(必填)</span>
        </div>
        <div class="printReceipt-item">
          <div>
            <span>临柜号</span>
            <el-input v-model="deliveryOrderPrint.numberPlate"></el-input>
            <span>(必填)</span>
          </div>
          <div>
            <span>体积（m³）</span>
            <el-input v-model="deliveryOrderPrint.totalVolume"></el-input>
            <span>(必填)</span>
          </div>
        </div>
        <div class="printReceipt-weight">
          <span>货物总重量(kg)</span>
          <el-input :value="deliveryOrderPrint.totalGrossWeight"></el-input>
          <span
            >(必填)货物清单如下(请勿更改表格格式，按照序号对应填写内容即可):</span
          >
        </div>
        <div class="printReceipt-table">
          <PrintTable :data="boxPrint" :columns="printColumns"> </PrintTable>
        </div>
        <div class="printReceipt-singerItem" style="width: 70%">
          <span>（必填）货物有问题请联系人&电话:</span>
          <el-input :value="deliveryOrderPrint.contact"></el-input>
        </div>
        <div class="printReceipt-remarkItem">
          <span>备注:</span>
          <div>
            <span
              >1、请贵司通知送货单位，凭我司进仓通知单和进仓编号进仓，仓库提供周到热忱的服务。
              （正常上班时上午：9:00:12:30、下午14:00-18:30，请提前30分钟到仓）</span
            >
            <span
              >2.如果有多个PO#，请于送货前分好并提供货号清单，否则客户将承担仓库收取的分唛费。</span
            >
            <span
              >3、（导航地址）仓库地址：{{
                deliveryOrderPrint.address
              }}预约二维码：</span
            >
            <span
              >收货联系人：{{
                deliveryOrderPrint.contacter
              }}&nbsp;&nbsp;&nbsp;电话：{{ deliveryOrderPrint.phone }}</span
            >
          </div>
        </div>
        <div class="printReceipt-imgItem">
          <vue-qr
            :text="downloadData.url"
            :margin="10"
            colorDark="#000"
            colorLight="#fff"
            :dotScale="1"
            :logoSrc="downloadData.icon"
            :logoScale="0.2"
            :size="200"
          ></vue-qr>
          <img src="../../../assets/navigation.png" />
        </div>
      </div>
    </el-dialog>

    <!-- 打印进仓单Cosco -->
    <el-dialog
      :visible.sync="printPickListCoscoVisible"
      v-model="printPickListCoscoVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      class="printDalog"
      title=""
      width="80%"
      style="text-align: center"
    >
      <el-row type="flex" class="row-bg printRow">
        <div class="print">
          <el-button
            v-print="printCoscoObj"
            type="primary"
            @click="printDeliveryOrder"
            >打印</el-button
          >
        </div>
      </el-row>

      <div
        id="printReceiptManageCosco"
        class="printReceipt"
        ref="printContentCosco"
      >
        <div v-html="styleText"></div>
        <div class="printReceipt-remark">
          入仓单(华南中远海运跨境电商集拼仓--塘夏)
        </div>
        <div class="printReceipt-barcode">
          <img id="barcode1" />
        </div>
        <div><span>注意:司机凭进仓单需一式两份交仓，没有进仓单的货物仓库有权拒收。请预约送货，未预约用户送货可能需要等待卸货。</span></div>
        <div class="printReceipt-item">
          <div>
            <span>客户名称</span>
            <el-input v-model="deliveryOrderPrint.ownerCode"></el-input>
          </div>
          <div>
            <span>目的地</span>
            <el-input v-model="deliveryOrderPrint.destination"></el-input>
          </div>
          <div>唛头</div>
        </div>
        <div class="printReceipt-item">
          <div>
            <span>客户入仓号</span>
            <el-input v-model="deliveryOrderPrint.deliveryOrdeNo"></el-input>
          </div>
          <div>
            <span>预计入仓时间</span>
            <el-input v-model="deliveryOrderPrint.estimatedDateText"></el-input>
          </div>
          <div>请在我司系统自动下载唛头模版，</div>
        </div>
        <div class="printReceipt-item">
          <div>
            <span>PO/原单号</span>
            <el-input v-model="deliveryOrderPrint.orgReceiptNo"></el-input>
          </div>
          <div>
          </div>
          <div>每票货必须要贴唛头才能入仓</div>
        </div>
        <div class="printReceipt-table">
          <PrintTable :data="boxPrint" :columns="printCoscoColumns">
          </PrintTable>
        </div>
        <div class="printReceipt-remarkItem">
          <div>
            <span>入仓注意事项：请按我司以上要求贴唛并将货物样品纸箱放置车子最末端（不同品名各放一箱）</span>
            <span
              >1、收货时间:仓库收货时间为周一到周日09:00~19:00。（法定节假日不收货）</span
            >
            <span
              >2、入仓程序：承运车辆到仓库后，请送货人先联系于超瑾/133 1693 4907凭此单办理卸货登记手续。仓库相关人员清点数量在此单签字返还给送货人。</span
            >
            <span
              >3、货物须在当天19点前到仓登记，如超过19点后按照每小时50元收取加班费用。</span
            >
            <span
              >4、如多票一车入仓，请务必随附详细的分货唛头以便仓库能及时入仓安排卸货；客户在每箱货物都要贴上相应的唛头。（贴唛要求：FBALABEL要贴在两个相邻的侧面，注意是两个相邻的侧面，不能贴在箱子上部或者底部；我司海运唛头请贴在FBALABEL旁（唛头一张即可）</span
            >
            <span
              >5、进仓货物名称务必真实，否则由此造成无法出货等问题由客人自行负责。</span
            >
            <span
              >6、货物必须入我司仓库，由我司清点货物，如卡板入我司仓库，我司有权拆卡板清点，抽验货物</span
            >
            <span
              >7、货物要求：（1）货物外箱需有可识别的唛头，如无唛头所造成的一切后果我司概不负责。（2）货物的包装需符合装卸运输要求，如因包装不善而引起的任何问题，我司概不负责。（3）我司不接受腐蚀品，易燃、易爆等危险物品及易腐烂物品入仓。（4）超长、超宽、超重（3吨以上）等特殊物品，请在入仓前询问是否可以装卸。</span
            >
            <span
              >8、实际入库货物务必请于委托清单保持一致，禁止携带或瞒报任何其他不适宜运输的危险物质或材料进入仓库，包含但不仅限于：危险品，有毒物品，传染性物质，放射性物质，腐蚀性物质，（参考国家相关法律、法规所规定的违禁品）；否则由客 户承担由此产生的一切后果。</span
            >
          </div>
        </div>
        <hr />
        <div style="text-align: left; padding-left: 60px;">扫码预约</div>
        <div class="printReceipt-imgItem">
          <vue-qr
            :text="downloadData.url"
            :margin="10"
            colorDark="#000"
            colorLight="#fff"
            :dotScale="1"
            :logoSrc="downloadData.icon"
            :logoScale="0.2"
            :size="200"
          ></vue-qr>
          <div style="text-align: left;">
            <span>导航地址：华南中远海运跨境电商集拼仓(塘厦)</span>
            <br/>
            <span>仓库地址：广东省东莞市塘厦镇西荣路96号华南中远海运跨境电商集拼仓（塘厦）收货台（塘厦韵达分公司对面物流园区）于超瑾/133 1693 4907</span>
            <br />
            <br />
            <span>货物及包装状况等异常描述：</span>
            <br />
            <br />
            <br />
            <span style="padding-right:242px;">仓库实际收货数量：</span>
            <span>签收人签名：</span>
            <br />
            <br />
            <br />
            <span style="padding-right:227px;">送货日期：{{ new Date().toLocaleDateString() }}</span>
            <span>送货人签名：</span>
          </div>
        </div>
        
      </div>
    </el-dialog>

    <addServicesDalog ref="addServicesDalogRef" :addServicesType="'add'" />

    <!-- 旧单库存数据 -->
    <el-dialog
      :visible.sync="shippingVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="旧单库存信息"
      width="90%"
      top="50px"
      style="text-align: center"
    >
      <div style="width: 100%; text-align: left; margin-bottom: 10px">
        <el-button type="primary" @click="onAddDeliveryOrder" style=""
          >确认</el-button
        >
      </div>
      <el-table
        :data="shippingdata"
        highlight-current-row
        border
        style="width: 100%"
        height="400"
        @row-click="handleOrderClick"
        @selection-change="selsChange"
        ref="multipleTable"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          prop="deliveryOrdeNo"
          label="WMS进仓号"
          align="center"
          sortable
        >
        </el-table-column>

        <el-table-column
          prop="orgCustomerNo"
          label="参考单号"
          align="center"
          sortable
        >
        </el-table-column>

        <el-table-column prop="boxCount" label="箱数" sortable align="center">
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      :visible.sync="boxMarkVisible"
      v-model="boxMarkVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="预约信息"
      width="60%"
      style="text-align: center"
    >
      <el-table
        :data="transferdata"
        highlight-current-row
        border
        style="width: 100%;heiht"
      >
        <el-table-column prop="bookingNo" label="预约单号"> </el-table-column>
        <el-table-column prop="expectedTimeDesc" label="预约时间" width="200">
        </el-table-column>
        <el-table-column prop="deliveryQty" label="箱数"></el-table-column>
        <el-table-column prop="deliveryWeight" label="重量"></el-table-column>
        <el-table-column
          prop="deliveryVolumeCbm"
          label="体积"
        ></el-table-column>
        <el-table-column prop="driverName" label="司机"></el-table-column>
        <el-table-column prop="driverCarNumber" label="车牌"></el-table-column>
        <el-table-column prop="driverPhone" label="电话"></el-table-column>
        <el-table-column
          prop="bookingStatusDesc"
          label="状态"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDeliveryOrderTaskAsync,
  exportDeliveryOrderAsync,
  insertTFSignFor,
  cancelTFDeliveryOrder,
  rollbackTFDeliveryOrder,
  asyncTFDeliveryOrder,
  examineDeliveryOrder,
  printDeliveryOrderAsync,
  forceCompleteDeliveryOrder,
  changeStockDeliveryOrder,
  getDeliveryBookingAsync,
} from "@/api/transfer/tfDelivery/receiptManage.js";
import { getButtonList } from "../../../promissionRouter";
import TwTable from "../../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../../components/TwTable/mixins";
import axios from "axios";
import { getTFTemporaryStorage } from "@/api/outbound/outboundOrder.js";
import { thereAre } from "util/util";
import LogDialog from "../../../components/TwTable/components/logDialog";
import hoverCopy from "../../../components/hoverCopy.vue";
import ReceiptNoDalog from "./AddTFDelivery.vue";
import JsBarcode from "jsbarcode";
import addServicesDalog from "../../AddServices/components/addServicesDalog.vue";
import WarehouseNoDetail from "./components/WarehouseNoDetail.vue";
import PrintTable from "../../../components/printTable.vue";
import html2canvas from "html2canvas";
import printJS from "print-js";
import vueQr from "vue-qr";
import { BaseRouterUrl } from "@/api/axios_config.js";
export default {
  components: {
    LogDialog,
    TwTable,
    ReceiptNoDalog,
    hoverCopy,
    vueQr,
    addServicesDalog,
    WarehouseNoDetail,
    PrintTable,
  },
  mixins: [TwTable_mixins, PrintTable],

  data() {
    return {
      styleText:
        '<style type="text/css" media="print">\n' +
        "  @page { size: portrait; }\n" +
        "</style>",
      activeName: "all",
      isDisabled: false,
      boxMarkVisible: false,
      transferdata: [],
      printObj: {
        id: "printReceiptManage",
        popTitle: "good print",
        extraCss:
          "https://cdn.bootcdn.net/ajax/libs/animate.css/4.1.1/animate.compat.css, https://cdn.bootcdn.net/ajax/libs/hover.css/2.3.1/css/hover-min.css",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
      },
      printCoscoObj: {
        id: "printReceiptManageCosco",
        popTitle: "good print",
        extraCss:
          "https://cdn.bootcdn.net/ajax/libs/animate.css/4.1.1/animate.compat.css, https://cdn.bootcdn.net/ajax/libs/hover.css/2.3.1/css/hover-min.css",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
      },
      DateTypeOptions: [
        {
          value: "b.CreateTime",
          label: "创建时间",
        },
        {
          value: "b.EstimatedDate",
          label: "预计到仓时间",
        },
      ],
      filters: {
        DateType: "b.CreateTime",
      },
      printColumns: [
        {
          prop: "xh",
          label: "序号(票数)",
          align: "center",
        },
        {
          prop: "",
          label: "海外仓入库单号(唛头)",
          align: "center",
          minWidth: "180",
        },
        {
          prop: "skuCode",
          label: "SKU(托信息货号)",
          align: "center",
          minWidth: "160",
        },
        {
          prop: "declareCName",
          label: "品名",
          align: "center",
        },
        {
          prop: "boxNo",
          label: "箱号",
          align: "center",
        },
        {
          prop: "boxCount",
          label: "件数",
          align: "center",
        },
      ],
      printCoscoColumns: [
        {
          prop: "declareCName",
          label: "品名",
          align: "center",
          minWidth: "180",
        },
        {
          prop: "skuCode",
          label: "SKU",
          align: "center",
        },
        {
          prop: "boxCount",
          label: "件数",
          align: "center",
          minWidth: "100",
        },
        {
          prop: "",
          label: "包装",
          align: "center",
        },
        {
          prop: "boxWeight",
          label: "重量(KGS)",
          align: "center",
          minWidth: "100",
        },
        {
          prop: "boxMark",
          label: "尺寸(CM)",
          align: "center",
          minWidth: "200",
        },
        {
          prop: "boxVolume",
          label: "体积(CBM)",
          align: "center",
          minWidth: "100",
        },
        {
          prop: "shipmentID",
          label: "shipmentID",
          align: "center",
          minWidth: "120",
        },
      ],
      tableConfig: {
        showResetButton: true,
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: true, // 显示操作栏
        operate: {
          //操作栏配置
          align: "center",
          width: "120",
          options: [
            {
              prop: "resynchronize",
              name: "日志",
              size: "small",
              type: "text",
              slot: true,
            },
            // {
            //   name: "日志",
            //   size: "small",
            //   type: "text",
            //   event: "getbusinessLoglist", // 操作的事件名
            // },
          ],
        },
        column: [
          // 表格列配置
          {
            prop: "customName",
            label: "客户",
            // align: "center",

            minWidth: "130",
          },
          {
            prop: "deliveryOrdeNo",
            label: "WMS进仓号",

            slot: true,
            minWidth: "180",
          },
          {
            prop: "orgCustomerNo",
            label: "参考单号",

            minWidth: "150",
          },
          {
            prop: "orgReceiptNo",
            label: "进仓单号",
            minWidth: "150",
          },
          {
            prop: "deliveryTypeText",
            label: "入库类型",
            minWidth: "120",
          },
          {
            prop: "isTransit",
            label: "是否中转",
            slot: true,
          },
          {
            prop: "statusText",
            label: "状态",
          },
          {
            prop: "warehouseName",
            label: "仓库",
          },
          {
            prop: "deliveryBooking",
            label: "预约信息",
            slot: true,
          },
          {
            prop: "totalBoxCount",
            label: "预报箱数",
          },
          {
            prop: "receivedBoxVolume",
            label: "预报体积",
          },
          {
            prop: "receivedBoxWeight",
            label: "预报重量",
          },
          {
            prop: "actualBoxCount",
            label: "签收箱数",
          },
          {
            prop: "receivedBoxCount",
            label: "实收箱数",
          },
          {
            prop: "inBoxCount",
            label: "上架箱数",
          },
          {
            prop: "isRecheckText",
            label: "是否复测",
          },
          {
            prop: "soNumber",
            label: "SO单号",
          },
          {
            prop: "deliveryDate",
            label: "装柜时间",
          },
          {
            prop: "driver",
            label: "联系人",
          },
          {
            prop: "driverPhone",
            label: "电话",
          },
          {
            prop: "numberPlate",
            label: "车牌号",
          },
          {
            prop: "estimatedDate",
            label: "预计到仓时间",

            minWidth: "140",
          },
          {
            prop: "createUser",
            label: "创建人",
          },
          {
            prop: "createTime",
            label: "创建时间",

            minWidth: "140",
          },
          {
            prop: "remark",
            label: "备注",

            minWidth: "140",
          },
        ],
      },
      searchData: {
        //搜索列配置

        search: [
          {
            type: "input",
            key: "key",
            label: "单据号",
            placeholder: "WMS进仓号/参考单号",
            clearable: true,
          },
          {
            type: "input",
            key: "orgReceiptNo",
            label: "进仓单号",
            placeholder: "进仓单号",
            clearable: true,
          },
          {
            type: "select",
            key: "Status",
            prop: "Status",
            label: "状态",
            multiple: true,
            slot: true,
            placeholder: "请选择状态",
            option: this.statusList,
          },
          {
            type: "select",
            key: "OrgIds",
            prop: "OrgIds",
            label: "客户货主",
            multiple: true,
            slot: true,
            placeholder: "请选择客户货主",
            option: this.organizationList,
          },
        ],
        ///高级搜索配置
        moreSearch: [
                    {
            type: "select",
            key: "WarehouseId",
            prop: "WarehouseId",
            label: "仓库",
            multiple: true,
            slot: true,
            placeholder: "请选择仓库",
            option: this.warehouses,
          },
          {
            key: "tdate",
            prop: "tdate",
            slot: true,
            label: "创建时间",
            hideLabel: true,
          },
          {
            type: "input",
            key: "boxMark",
            label: "箱唛号",
            placeholder: "箱唛号",
            clearable: true,
          }
        ],
      },
      InOutDetailTableConfig: {
        title: "进仓单明细",
        width: "70%",
        loading: true, // 显示loading状态
        showPage: true,
        column: [
          // 表格列配置
          {
            prop: "customerBox",
            label: "箱号",
            align: "center",
            minWidth: "150",
          },
          {
            prop: "boxMark",
            label: "箱唛",
            align: "center",
            minWidth: "150",
          },
          {
            prop: "markHead",
            label: "唛头",
            align: "center",
            minWidth: "150",
          },
          {
            prop: "ownerCode",
            label: "货主代码",
            align: "center",

            minWidth: "100",
          },
          {
            prop: "boxWeight",
            label: "毛重（kg）",
            align: "center",

            minWidth: "120",
          },
          {
            prop: "boxVolume",
            label: "体积(cbm)",
            align: "center",
            minWidth: "100",
          },
          {
            prop: "boxLength",
            label: "长(cm)",
            align: "center",

            minWidth: "100",
          },
          {
            prop: "boxWidth",
            label: "宽(cm)",
            align: "center",
            minWidth: "100",
          },
          {
            prop: "boxHeight",
            label: "高(cm)",
            align: "center",
            minWidth: "100",
          },
          {
            prop: "quantity",
            label: "数量",
            align: "center",
          },
          {
            prop: "declareCName",
            label: "中文申报名称",
            align: "center",
            minWidth: "150",
          },

          {
            prop: "declareEName",
            label: "英文申报名称",
            align: "center",

            minWidth: "140",
          },
          {
            prop: "electricity",
            label: "是否含电",
            align: "center",

            minWidth: "100",
          },
        ],
      },

      buttonList: [],
      //------签收
      addFormVisible: false,
      addLoading: false,
      addForm: {
        TFDeliveryOrderID: 0,
        OrgReceiptNo: "",
        DeliveryOrdeNo: "",
        orgCustomerNo: "",
        BoxCount: 0,
        ActualBoxCount: null,
        ActualArriveDate: new Date(),
        IsUnload: [],
        Remark: "",
        ReceivedBoxCount: 0,
        IsSyc: false,
      },
      addFormRules: {
        ActualArriveDate: [
          {
            required: true,
            message: "请选择实际到仓时间",
            trigger: "blur",
          },
        ],
        ActualBoxCount: [
          {
            required: true,
            message: "请输入正确的签收箱数",
            trigger: "blur",
            //pattern: /^[+]?[0-9]?$/,
          },
        ],
      },
      showDialogInout: false,
      //-------------
      shippingdata: [],
      shippingSels: [],
      shippingVisible: false,
      newDeliveryOrderID: 0,
      warehouses: [],
      organizationList: [], //客户货主
      statusList: [
        {
          value: 10,
          text: "待审核",
        },
        {
          value: 20,
          text: "已审核",
        },
        {
          value: 30,
          text: "已签收",
        },
        {
          value: 35,
          text: "部分签收",
        },
        {
          value: 40,
          text: "部分收货",
        },
        {
          value: 45,
          text: "强制完成",
        },
        {
          value: 50,
          text: "收货完成",
        },
        {
          value: 88,
          text: "异常",
        },
        {
          value: 99,
          text: "取消",
        },
      ], //同步状态
      allKinds: {
        auditCount: 0,
        reviewedCount: 0,
        signInCount: 0,
        partialSignInCount: 0,
        partialReceiptCount: 0,
        forceCompleteCount: 0,
        receiptCompletedCount: 0,
        abnormalCount: 0,
        cancelCount: 0,
      },
      proListVisible: false,
      printPickListVisible: false,
      printPickListCoscoVisible: false,
      boxPrint: [],
      downloadData: {
        url: (BaseRouterUrl===''?'http://wms.shippingself.com':BaseRouterUrl) + "/mobile/reserveItems?key=", //需要转化成二维码的网址
        // icon: require('./xxx.jpg')  //二维码中间的图片,可以不设置
      },
      deliveryOrderPrint: {
        numberPlate: "",
        driverPhone: "",
        deliveryUnit: "",
        totalVolume: "",
        totalGrossWeight: "",
        contact: "",
      },
    };
  },
  methods: {
    getBoxMarkTransfer(trackNumber) {
      let pata = { trackNumber };
      this.transferdata = [];
      this.boxMarkVisible = true;
      getDeliveryBookingAsync(pata).then((res) => {
        if (res.data.success) {
          this.transferdata = res.data.response;
        } else {
          this.$message({
            message: "预约信息查询失败",
            type: "error",
          });
        }
      });
    },
    machineSyc(isSyc) {
      console.log("复选框状态改变:", isSyc);
      if (isSyc) {
        this.addForm.ActualBoxCount = this.addForm.MachineBoxCount;
      } else {
        this.addForm.ActualBoxCount = "";
      }
      this.isDisabled = isSyc;
    },
    changeCheck(va, val) {
      let newVa = va.at(-1);
      this.$set(this.addForm, "IsUnload", newVa ? [newVa] : []);
    },
    handleClick(tab, event) {
      let searchDeep = JSON.parse(JSON.stringify(this.searchData.search));
      searchDeep.forEach((item) => {
        if (item.key == "Status" && this.activeName !== "all") {
          item.hide = true;
        } else {
          item.hide = false;
        }
      });
      this.filters.Status = [];
      if (this.activeName !== "all") {
        var arr = [this.activeName * 1];
        this.$set(this.filters, "Status", arr);
      }

      this.$set(this.searchData, "search", searchDeep);
      this.newfilters = JSON.parse(JSON.stringify(this.filters));
      this.initTable();
    },
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.newfilters = JSON.parse(JSON.stringify(this.filters));
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },

    toImg() {
      // 转图片打印
      html2canvas(this.$refs.printContent, {
        backgroundColor: null,
        useCORS: true,
        windowHeight: document.body.scrollHeight,
      }).then((canvas) => {
        // let url = canvas.toDataURL('image/jpeg', 1.0)
        const url = canvas.toDataURL();
        this.img = url;
        printJS({
          printable: url,
          type: "image",
          documentTitle: "进仓单",
          style: "@page {margin:0 10mm};",
        });
        console.log(url);
      });
    },

    //打印进仓单查询
    printPickList() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }

      this.downloadData.url =
        (BaseRouterUrl===''?'http://wms.shippingself.com':BaseRouterUrl) + "/mobile/reserveItems?key=" + row[0].deliveryOrdeNo;
      printDeliveryOrderAsync({
        deliveryOrderID: row[0].tfDeliveryOrderID,
      }).then((res) => {
        if (res.data.success) {
          if (row[0].orgID == 9) {
            //cosco
            this.printPickListCoscoVisible = true;
            this.boxPrint = res.data.response.boxInfoList;
            this.deliveryOrderPrint = res.data.response;
            this.$nextTick(() => {
              JsBarcode("#barcode1", row[0].orgReceiptNo, {
                format: "CODE128", //条形码的格式
                font: "-apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC', 'miui', 'Hiragino Sans GB', 'Microsoft Yahei', sans-serif",
                displayValue: true,
                width: 2, //线宽
                height: 80, //条码高度
                lineColor: "#000", //线条颜色
                displayValue: true, //是否显示文字
                margin: 2, //设置条形码周围的空白区域
              });
            });
          } else {
            this.printPickListVisible = true;
            this.boxPrint = res.data.response.boxInfoList;
            this.deliveryOrderPrint = res.data.response;
            this.$nextTick(() => {
              JsBarcode("#barcode1", row[0].deliveryOrdeNo, {
                format: "CODE128", //条形码的格式
                font: "-apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC', 'miui', 'Hiragino Sans GB', 'Microsoft Yahei', sans-serif",
                displayValue: true,
                width: 2, //线宽
                height: 80, //条码高度
                lineColor: "#000", //线条颜色
                displayValue: false, //是否显示文字
                margin: 2, //设置条形码周围的空白区域
              });
            });
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //打印进仓单
    printDeliveryOrder() {
      // let row = this.selectRows.rows;
      // if (row == null || row.length == 0) {
      //   this.$message({
      //     message: "请选择一行数据！",
      //     type: "error",
      //   });
      //   return;
      // }
      // if (row != null && row.length > 1) {
      //   this.$message({
      //     message: "请选择一行数据,不能多选！",
      //     type: "error",
      //   });
      //   return;
      // }
      // var that = this;
      // that.toImg();
      // this.printPickListVisible = false;
    },

    //新增进仓单
    addTFDelivery() {
      this.$refs.ReceiptNoRef.showDialog(0);
    },
    //修改进仓单
    editTFDelivery() {
      if (this.selectRows.rows == null || this.selectRows.rows.length != 1) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }

      if (this.selectRows.rows[0].status !== 10) {
        this.$message({
          message: "请选择状态为[待审核]进仓单！",
          type: "error",
        });

        return;
      }
      this.$refs.ReceiptNoRef.showDialog(
        this.selectRows.rows[0].tfDeliveryOrderID
      );
    },
    //取消进仓单
    cancelTFDelivery() {
      if (this.selectRows.rows == null || this.selectRows.rows.length != 1) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }
      if (
        this.selectRows.rows[0].status !== 10 &&
        this.selectRows.rows[0].status !== 20
      ) {
        this.$message({
          message: "请选择状态为[待审核、已审核]进仓单！",
          type: "error",
        });

        return;
      }

      var orgCustomerNos = this.selectRows.rows
        .map((item) => item.orgCustomerNo)
        .join(",");
      this.$confirm("确认取消进仓单[" + orgCustomerNos + "]吗？", "提示", {})
        .then(() => {
          var para = {
            orgCustomerNos,
          };

          cancelTFDeliveryOrder(para).then((res) => {
            console.log(res);
            if (res.data.success) {
              this.initTable();
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //回滚进仓单
    rollbackTFDelivery() {
      if (this.selectRows.rows == null || this.selectRows.rows.length != 1) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }
      if ([10, 20, 99, 88].includes(this.selectRows.rows[0].status)) {
        this.$message({
          message: "请选择状态正常且已签收的进仓单！",
          type: "error",
        });

        return;
      }

      var orgCustomerNos = this.selectRows.rows
        .map((item) => item.orgCustomerNo)
        .join(",");
      this.$confirm("确认回滚进仓单[" + orgCustomerNos + "]吗？", "提示", {})
        .then(() => {
          var para = {
            orgCustomerNos,
          };

          rollbackTFDeliveryOrder(para).then((res) => {
            console.log(res);
            if (res.data.success) {
              this.initTable();
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //同步进仓单
    synchTFDelivery() {
      if (this.selectRows.rows == null || this.selectRows.rows.length != 1) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }
      if ([10, 20, 99, 88].includes(this.selectRows.rows[0].status)) {
        this.$message({
          message: "请选择状态正常且已签收的进仓单！",
          type: "error",
        });

        return;
      }

      if (this.selectRows.rows[0].inBoxCount==0) {
        this.$message({
          message: "请选择已上架的进仓单！",
          type: "error",
        });

        return;
      }
      if (this.selectRows.rows[0].orgID!=9) {
        this.$message({
          message: "请选择cosco的进仓单！",
          type: "error",
        });

        return;
      }

      var orgDeliveryNo = this.selectRows.rows
        .map((item) => item.orgDeliveryNo)
        .join(",");
      this.$confirm("确认同步进仓单[" + orgDeliveryNo + "]吗？", "提示", {})
        .then(() => {
          var para = {
            orgDeliveryNo,
          };

          asyncTFDeliveryOrder(para).then((res) => {
            console.log(res);
            if (res.data.success) {
              this.initTable();
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //审核进仓单
    examineTFDelivery() {
      if (this.selectRows.rows == null || this.selectRows.rows.length != 1) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }
      if (this.selectRows.rows[0].status !== 10) {
        this.$message({
          message: "请选择状态为[待审核]进仓单！",
          type: "error",
        });

        return;
      }

      var orgCustomerNos = this.selectRows.rows
        .map((item) => item.orgCustomerNo)
        .join(",");
      this.$confirm("确认审核进仓单[" + orgCustomerNos + "]吗？", "提示", {})
        .then(() => {
          var para = {
            deliveryOrderID: this.selectRows.rows[0].tfDeliveryOrderID,
          };

          examineDeliveryOrder(para).then((res) => {
            console.log(res);
            if (res.data.success) {
              this.initTable();
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //转移库存
    changeStock() {
      if (this.selectRows.rows == null || this.selectRows.rows.length != 1) {
        this.$message({
          message: "请选择一条新进仓单！",
          type: "error",
        });
        return;
      }
      if (this.selectRows.rows[0].status !== 20) {
        this.$message({
          message: "请选择状态为[已审核]进仓单！",
          type: "error",
        });

        return;
      }
      this.newDeliveryOrderID = this.selectRows.rows.map(
        (item) => item.tfDeliveryOrderID
      )[0];
      console.info(this.newDeliveryOrderID);
      var warehouseCode = this.selectRows.rows
        .map((item) => item.warehouseCode)
        .join(",");
      var orgId = this.selectRows.rows.map((item) => item.orgID).join(",");
      let pata = {
        warehouseCode: warehouseCode,
        orgId: orgId,
      };
      this.shippingdata = [];
      this.shippingVisible = true;
      getTFTemporaryStorage(pata).then((res) => {
        if (res.data.success) {
          this.shippingdata = res.data.response;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //选择进仓单
    onAddDeliveryOrder() {
      var shippingData = this.shippingSels;
      if (shippingData == null || shippingData.length == 0) {
        this.$message({
          message: "至少选择一行数据！",
          type: "error",
        });
        return;
      }
      var arr = [];

      var deliveryOrderIDs = shippingData
        .map((item) => item.tfDeliveryOrderID)
        .join(",");
      var para = {
        newDeliveryOrderID: this.newDeliveryOrderID,
        deliveryOrderIDs: deliveryOrderIDs,
      };

      changeStockDeliveryOrder(para).then((res) => {
        if (res.data.success) {
          this.shippingVisible = false;
          this.initTable();
          this.$message({
            message: res.data.msg,
            type: "success",
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //强制完成进仓单
    forceCompleteTFDelivery() {
      if (this.selectRows.rows == null || this.selectRows.rows.length != 1) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }
      if (![20, 35, 40].includes(this.selectRows.rows[0].status)) {
        this.$message({
          message: "请选择状态为【已审核】【部分签收】【部分收货】进仓单！",
          type: "error",
        });

        return;
      }

      var orgCustomerNos = this.selectRows.rows
        .map((item) => item.orgCustomerNo)
        .join(",");
      this.$confirm(
        "确认强制完成进仓单[" +
          orgCustomerNos +
          "]吗(强制完成后仓库将不继续收货)？",
        "提示",
        {}
      )
        .then(() => {
          var para = {
            deliveryOrderID: this.selectRows.rows[0].tfDeliveryOrderID,
          };

          forceCompleteDeliveryOrder(para).then((res) => {
            console.log(res);
            if (res.data.success) {
              this.initTable();
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    resetBtn() {
      this.filters = {
        DateType: "b.CreateTime",
      };
      this.$set(this.filters, "status", []);
    },
    //查询列表
    initTable() {
      const {
        WarehouseId,
        Status,
        key,
        tdate,
        DateType,
        OrgIds,
        orgReceiptNo,
        boxMark,
      } = this.newfilters;

      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        key,
        OrgIds: thereAre(OrgIds),
        WarehouseIDs: thereAre(WarehouseId),
        Status: thereAre(Status),
        orgReceiptNo,
        DateType,
        boxMark,
      };
      if (tdate != null && tdate != "null" && tdate != "") {
        para.StartDate = tdate[0];
        para.EndDate = tdate[1];
      }
      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      getDeliveryOrderTaskAsync(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;
        console.log(pageData);
        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);
        this.tableData = pageData;
        if (pageData.length > 0) {
          this.allKinds.auditCount = pageData[0].auditCount;
          this.allKinds.reviewedCount = pageData[0].reviewedCount;
          this.allKinds.signInCount = pageData[0].signInCount;
          this.allKinds.partialSignInCount = pageData[0].partialSignInCount;
          this.allKinds.partialReceiptCount = pageData[0].partialReceiptCount;
          this.allKinds.receiptCompletedCount =
            pageData[0].receiptCompletedCount;
          this.allKinds.abnormalCount = pageData[0].abnormalCount;
          this.allKinds.cancelCount = pageData[0].cancelCount;
          this.allKinds.forceCompleteCount = pageData[0].forceCompleteCount;
        } else {
          this.allKinds.auditCount = 0;
          this.allKinds.reviewedCount = 0;
          this.allKinds.signInCount = 0;
          this.allKinds.partialSignInCount = 0;
          this.allKinds.partialReceiptCount = 0;
          this.allKinds.receiptCompletedCount = 0;
          this.allKinds.abnormalCount = 0;
          this.allKinds.cancelCount = 0;
          this.allKinds.forceCompleteCount = 0;
        }
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },
    //导出
    handleExport() {
      let row = this.selectRows.rows;
      let TFDeliveryOrderIDs = row
        .map((item) => item.tfDeliveryOrderID)
        .join(",");
      const { WarehouseIDs, Status, key, tdate, DateType, OrgReceiptNo } =
        this.newfilters;
      let para = {
        page: 1,
        pageSize: 60001,
        key,

        WarehouseIDs: thereAre(WarehouseIDs),
        Status: thereAre(Status),
        TFDeliveryOrderIDs,
        DateType,
      };
      if (tdate != null && tdate != "null" && tdate != "") {
        para.StartDate = tdate[0];
        para.EndDate = tdate[1];
      }
      this.exportFile(exportDeliveryOrderAsync, para);
    },
    getdate()
    {
      let yy = new Date().getFullYear();
      //let mm = new Date().getMonth() + 1;
      let mm =new Date().getMonth() + 1 < 10? "0" + (new Date().getMonth() + 1): new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let gettime = yy + "-" + mm + "-" + dd;
      return gettime;
    },
    // 新增增值服务
    addServices() {
      if (this.selectRows.rows && this.selectRows.rows.length === 1) {
        if (this.selectRows.rows[0].status == 10) {
          this.$message({
            message: "待审核状态的不能添加增值服务",
            type: "error",
          });
        } else {
          
          this.selectRows.rows[0].ecTimeText=this.getdate();
          console.info(this.selectRows.rows[0]);
          this.$refs.addServicesDalogRef.showDalog(this.selectRows.rows[0]);
        }
      } else {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
      }
    },
    //查询日志
    getbusinessLoglist(row) {
      this.currentRow = row;
      this.showLog = true;
    },
    //查询明细
    batchesDetail(rows) {
      this.$refs.WarehouseNoDetailRef.showDalog(rows);
    },
    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },

    handleOrderClick(row, column, event) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },

    //多选
    selsChange(sels) {
      this.shippingSels = sels;
    },

    //弹出签收框
    onSubmitadd() {
      if (this.selectRows.rows == null || this.selectRows.rows.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }
      if (this.selectRows.rows != null && this.selectRows.rows.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });

        return;
      }
      if (![20, 35, 40].includes(this.selectRows.rows[0].status)) {
        this.$message({
          message: "请选择状态为【已审核】【部分签收】【部分收货】进仓单！",
          type: "error",
        });

        return;
      }

      this.addForm.OrgReceiptNo = this.selectRows.rows[0].orgReceiptNo;
      this.addForm.IsUnload = [];
      this.addForm.DeliveryOrdeNo = this.selectRows.rows[0].deliveryOrdeNo;
      this.addForm.orgCustomerNo = this.selectRows.rows[0].orgCustomerNo;
      this.addForm.BoxCount = this.selectRows.rows[0].totalBoxCount;
      this.addForm.TFDeliveryOrderID =
        this.selectRows.rows[0].tfDeliveryOrderID;
      this.addForm.ReceivedBoxCount = this.selectRows.rows[0].receivedBoxCount;
      this.addForm.MachineBoxCount = this.selectRows.rows[0].machineBoxCount;
      this.addForm.IsSyc = false;
      this.addForm.Remark = this.selectRows.rows[0].remark;
      if (this.addForm.TFDeliveryOrderID <= 0) {
        this.$message({
          message: "入库单数据错误，请刷新页面！",
          type: "error",
        });
      }
      console.info(new Date());
      this.addForm.ActualArriveDate = new Date();
      this.addFormVisible = true;
      this.addLoading = false;
    },
    //隐藏签收框
    onSubmicancel() {
      this.addFormVisible = false;
      this.$refs["addRuleForm"].resetFields();
    },
    //签收
    onAddSubmit() {
      let para = Object.assign({}, this.addForm);
      //console.info(para);
      let _this = this;
      console.log(
        _this.addForm.ReceivedBoxCount + _this.addForm.ActualBoxCount
      );
      if (
        parseInt(_this.addForm.BoxCount) <
        parseInt(_this.addForm.ReceivedBoxCount) +
          parseInt(_this.addForm.ActualBoxCount)
      ) {
        this.$message({
          message: "签收数量不能大于剩余可签收数量",
          type: "error",
        });
        return;
      }
      if (!para.IsUnload.length) {
        this.$message({
          message: "请选择卸货方式",
          type: "error",
        });
        return;
      }
      para.IsUnload = para.IsUnload.includes("warehouseUnloading");

      this.$refs.addRuleForm.validate((valid) => {
        if (valid) {
          var user = JSON.parse(window.localStorage.user);
          if (!user && user.id == 0) {
            this.$message({
              message: "用户信息为空，先登录",
              type: "error",
            });
            _this.$router.replace(
              _this.$route.query.redirect ? _this.$route.query.redirect : "/"
            );
          }

          if (_this.addForm.BoxCount != _this.addForm.ActualBoxCount) {
            this.$confirm("预报箱数与实收箱数不一致，确认签收吗？", "提示", {})
              .then(() => {
                this.addLoading = true;
                insertTFSignFor(para).then((res) => {
                  this.addLoading = false;
                  console.log(res);
                  if (res.data.success) {
                    this.addFormVisible = false;
                    this.$refs["addRuleForm"].resetFields();
                    this.initTable();
                    this.$message({
                      message: res.data.msg,
                      type: "success",
                    });
                  } else {
                    this.$message({
                      message: res.data.msg,
                      type: "error",
                    });
                  }
                });
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            this.addLoading = true;
            insertTFSignFor(para).then((res) => {
              this.addLoading = false;
              console.log(res);
              if (res.data.success) {
                this.addFormVisible = false;
                this.$refs["addRuleForm"].resetFields();
                this.initTable();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          }
        }
      });
    },
  },

  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);

    let user = JSON.parse(window.localStorage.user);
    this.warehouses = user.warehouseList;
    this.organizationList = user.organizationList;
  },
};
</script>
<style scoped>
.el-date-editor.el-input {
  width: 100% !important;
}
.warehouseCls {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
.actualArriveDate {
  margin-bottom: 10px !important;
}
.dateSelect {
  width: 130px;
  margin-right: 12px;
}
.inline {
  display: flex;
}
.printList {
  font-size: 14px;
  margin-bottom: 14px;
  margin: auto 0;
}

.printList strong {
  line-height: 50px;
}
</style>

<style lang="less">
.printReceipt {
  &-remark {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 6px;
    text-align: center;
  }
  &-warehouseName {
    font-size: 25px;
    font-weight: bold;
    text-align: center;
  }
  &-barcode {
    display: flex;
    justify-content: flex-end;
    img {
      width: 30%;
    }
  }
  &-singerItem {
    display: flex;
    width: 50%;
    align-items: flex-end;
    justify-content: center;
    margin-bottom: 6px;
    .el-input {
      flex: 1;
      margin: 0 4px;
    }
  }
  &-item {
    display: flex;
    gap: 10px;
    align-items: flex-end;
    margin-bottom: 6px;
    > div {
      flex: 1;
      display: flex;
      align-items: flex-end;
      justify-content: center;
    }
    .el-input {
      flex: 1;
      margin: 0 4px;
    }
  }
  &-weight {
    display: flex;
    margin-bottom: 6px;
    align-items: flex-end;
    .el-input {
      flex: 1;
      margin: 0 4px;
    }
  }
  &-remarkItem {
    display: flex;
    gap: 4px;
    > div:last-child {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      text-align: left;
      > span {
        margin-bottom: 4px;
      }
    }
  }
  &-table {
    .el-table--medium .el-table__cell {
      padding: 3px 0;
    }
  }
  &-imgItem {
    display: flex;
    justify-content: space-evenly;
    img:last-child {
      width: 450px;
      height: auto;
    }
  }
  .el-input__inner {
    border-radius: 0px;
    border-top-width: 0px;
    border-left-width: 0px;
    border-right-width: 0px;
    border-bottom-width: 1px;
    border-bottom-color: #000;
    color: #000;
    padding-top: 4px;
    font-size: 15px;
    padding-left: 3px;
    height: 27px;
    line-height: 27px;
  }
}
.printDalog {
  .el-dialog__body {
    padding-top: 0;
    color: #000;
  }
}
.receiptRow {
  display: flex;
  margin-bottom: 10px;
  > div {
    flex: 1;
    > div {
      margin-bottom: 10px;
      > span {
        display: inline-block;
      }
      > span:first-child {
        width: 130px;
        text-align: right;
        margin-right: 10px;
      }
      > span:last-child {
        color: #000;
      }
    }
  }
}
.printRow {
  position: absolute;
  right: 20px;
  z-index: 99999999;
}

.printList th,
.printList td {
  color: #000;
  border-right: 1px solid #000 !important;
  border-bottom: 1px solid #000 !important;
}
</style>

<style type="text/css" media="print">
@page {
  margin-top: 5mm;
  margin-bottom: 18mm;
  padding-top: 5mm;
}
</style>
